import { set, toggle } from '@/utils/vuex';
import defaultState from "./state";

export default {
  resetState: state => {
    state =  Object.assign({}, defaultState)
    state.authenticated = false
  },
  setSelect (state, select) {
    state.settings.select = Object.assign(state.settings.select, select)
  },
  setUser (state, user) {
    state.settings._user = Object.assign(state.settings._user, user)
  },
  resetRelation(state) {
    state.role = state.settings.role
    state.contacts = state.settings.contacts
    state.relation = state.settings.relation
  },
  setRelation (state, relation) {
    state.role = relation._type
    state.relation =  relation
    state.contacts =  relation.contacts
  },
  setContacts (state, contacts) {
    state.contacts = contacts
  },
  loading (state, loading) {
   state.loading = loading;
  },
  loginRequest (state, credentials) {
    // state.authenticated = true
    // state.settings = credentials
  },
  loginSuccess (state, settings) {
    state.authenticated = true
    state.role = settings.role
    state.token = settings.token
    state.settings = settings
    state.contacts = settings.contacts
    state.relation = settings.relation
  },
  loginFailure (state) {
    state = Object.assign({}, defaultState)
  },
  logout (state) {
    state.authenticated = false
    state.role = ''
    state.token = null
    state.settings = {}
    state.contacts = []
    state.relation = {}
    
  },
  socket_authentication (state, settings){
    state.authenticated = true
    state.role = settings.role
    state.token = settings.token
    state.settings = settings
    state.contacts = settings.contacts
    state.relation = settings.relation
  },
  socket_invalid_login (state, message) {
    console.log('invalid login', message)
    /*state.authenticated = false
    state.role = ''
    state.token = null
    state.settings = {}
    state.contacts = []
    state.relation = {}*/
  },
  socket_online (state, user) {
    var s = state.settings.contacts.filter(e => e.email === user.email)[0]
    user.online = true
    if (!s) return state.contacts.push(user)
    s.token = user.token
    s.online = true
  },
  socket_offline (state, user) {
    var s = state.settings.contacts.filter(e => e.email === user.email)[0]
    if (!s) return state.settings.contacts.push(user)
    delete s.token
    s.online = false
  },
  socket_logout (state, user) {
    console.log('server logout')
  }
};
